<template>
  <v-dialog
    v-on="$listeners"
    v-bind="$attrs"
    @click:outside="close"
    width="400"
  >
    <v-card>
      <v-card-title>
        {{
          posTypeData?.id
            ? $t("pos-types.edit-pos-type")
            : $t("pos-types.register-pos-type")
        }}
      </v-card-title>

      <v-card-text class="mt-4">
        <v-form ref="form" @submit.prevent="handleSubmit">
          <v-row>
            <v-col cols="12">
              <BaseTextField
                v-model="description"
                :label="$t('pos-types.description')"
                :placeholder="$t('pos-types.insert-description')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <BaseSelect
                v-model="status"
                label="Status"
                :placeholder="$t('pos.select-status')"
                :persistent-placeholder="false"
                :rules="[rules.required]"
                :items="statusOptions()"
                item-text="text"
                item-value="value"
              />
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn @click="close" color="primary" outlined rounded>
                {{ $t("common.cancel") }}
              </v-btn>
              <BaseButton
                :loading="updatePosTypesLoading"
                variant="filter"
                class="ml-3"
                type="submit"
              >
                {{ $t("common.save") }}
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { statusOptions } from "../../utils";
import BaseTextField from "../forms/BaseTextField.vue";
import BaseSelect from "../forms/BaseSelect.vue";
import BaseButton from "../forms/BaseButton.vue";
import formRules from "../../mixins/formRules";

export default {
  name: "ModalPosTypeSettings",
  mixins: [formRules],
  components: {
    BaseTextField,
    BaseSelect,
    BaseButton,
  },
  props: {
    posTypeData: {
      type: Object,
    },
  },
  data() {
    return { statusOptions, description: "", status: "" };
  },
  computed: {
    ...mapGetters(["updatePosTypesLoading"]),
  },
  methods: {
    ...mapActions(["registerPosType", "updatePosType", "handlePosType"]),
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;

      await this.handlePosType({
        type: this.posTypeData?.id ? "update" : "register",
        posType: {
          description: this.description,
          status: this.status === "ATIVO" ? 1 : 0,
          posTypeId: this.posTypeData?.id || "",
        },
      });

      this.close();
    },
    close() {
      this.$emit("close");
      this.$refs.form.reset();
    },
  },
  mounted() {
    if (this.posTypeData) {
      this.description = this.posTypeData.description;
      this.status = this.posTypeData.status;
    }
  },
};
</script>

<style lang="scss" scoped></style>
